'use client'

import { useTranslation } from './provider'
import { directionFor, type TextDirection } from './direction'

/** 'rtl' when the chosen UI language reads right-to-left (Arabic), else 'ltr'. */
export function useTextDirection(): TextDirection {
  const { locale } = useTranslation()
  return directionFor(locale)
}
